import { isFeatureEnabled } from 'Context/FeaturesContext/FeaturesContext.helpers';
import { FEATURES } from 'Context/FeaturesContext/FeaturesContextConsts';

let GA_USER = null;

export const GA_TRACKING_ID = 'G-4YPX2KLG4X';

export const event = ({
	action,
	isLegacyEvent = true,
	...eventParams // eslint-disable-line camelcase
}) => {
	if (!window.gtag) return;
	const isAnalyticsEventLoggerEnabled = isFeatureEnabled(FEATURES.analyticsEventLogger);

	if (isAnalyticsEventLoggerEnabled && isLegacyEvent) {
		// eslint-disable-next-line no-console
		console.info(action, {
			action,
			...eventParams,
		});
	}

	window.gtag('event', action, {
		...eventParams,
	});
};

export const setGAUser = (user) => {
	GA_USER = user;
};

export const initGAUser = () => {
	const gaUserProperties = Number.isInteger(GA_USER?.id)
		? {
				dealer_id: GA_USER?.dealerId.toString(),
				user_id: GA_USER?.id.toString(),
		  }
		: {};

	window.gtag('set', 'user_properties', gaUserProperties);
};
